module.exports = __webpack_public_path__ + "static/media/6-ingenieurs.e0142d6d.png";